import { render, staticRenderFns } from "./InterventionView.vue?vue&type=template&id=2a7224a8&scoped=true"
import script from "./InterventionView.vue?vue&type=script&lang=js"
export * from "./InterventionView.vue?vue&type=script&lang=js"
import style0 from "./InterventionView.vue?vue&type=style&index=0&id=2a7224a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7224a8",
  null
  
)

export default component.exports